module.exports = __webpack_public_path__ + "static/media/Sentient_WallRun.6a66cd3e.gif";